import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-semibold text-lg" }
const _hoisted_2 = { class: "py-4" }
const _hoisted_3 = { class: "modal-action" }

import { VueFinalModal } from "vue-final-modal";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalConfirm',
  props: {
    title: {},
    cancelName: {},
    confirmName: {}
  },
  emits: ["done"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "flex justify-center items-center",
    "content-class": "modal-box"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.title), 1),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-ghost",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('done', false)))
        }, _toDisplayString(_ctx.cancelName ?? "Cancel"), 1),
        _createElementVNode("button", {
          class: "btn btn-accent",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('done', true)))
        }, _toDisplayString(_ctx.confirmName ?? "Confirm"), 1)
      ])
    ]),
    _: 3
  }))
}
}

})